<template>
  <router-view/>
</template>

<script>
export default {
    name: 'Cadastros'
}
</script>

<style scoped>

</style>